import config from '../config'
import http from '../http'

export default{
	getInquiryOrder:async function(payload) {
		const res = await http({
			url: config.GET_INQUIRY_ORDER_API,
			method: 'post',
			data: {
				...payload
			}
		})
		return res.data
	},
	getcategory:async function(payload) {
		const res = await http({
			url: config.GET_CATEGORY_API,
			method: 'post',
			data: {
				...payload
			}
		})
		return res.data
	},
	createInquiryOrder:async function(payload) {
		const res = await http({
			url: config.CREATE_INQUIRY_ORDER_API,
			method: 'post',
			data: {
				...payload
			}
		})
		return res.data
	},
	getCleanPrice:async function(payload) {
		const res = await http({
			url: config.GET_PRICE_CLEAN,
			method: 'post',
			data: {
				...payload
			}
		})
		return res.data
	},
    //上架到分销平台
	putAwayToDistribution:async function(payload) {
		const res = await http({
			url: config.DISTRIBUTION,
			method: 'post',
			data: {
				...payload
			}
		})
		return res.data
	},

	soldOutWholePsku:async function(payload) {
		const res = await http({
			url: config.SOLDOUT_PRODUCT,
			method: 'post',
			data: {
				...payload
			}
		})
		return res.data
	},
	//上架子sku
	shelfChildrenSku:async function(payload) {
		const res = await http({
			url: config.PUT_AWAY,
			method: 'post',
			data: {
				...payload
			}
		})
		return res.data
	},

	//下架子sku
	undershelfChildrenSku:async function(payload) {
		const res = await http({
			url: config.OUT_SHELFT,
			method: 'post',
			data: {
				...payload
			}
		})
		return res.data
	},

	//修改分销产品单个sku的价格
	modifyPrice:async function(payload) {
		const res = await http({
			url: config.UPDATAPRICE,
			method: 'post',
			data: {
				...payload
			}
		})
		return res.data
	},




	
}
